module.exports = __webpack_public_path__ + "static/living-108087991aaa3184b362d429c8d6ef25.jpg";